import { Component, OnInit, Renderer2 } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { Title } from '@angular/platform-browser';
import { KeyValue } from './shared/key-value';
import { environment } from '../environments/environment';
import { AuthorizationService } from './shared/authorization.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { WebsocketService } from './shared/websocket.service';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app works!';
  user_email: any;
  nick_name: string;
  first_name: string;
  last_name: string;
  selectedSession: any;
  cable: any;
  animStatus: any;
  uid: any;
  authChannelSocket: any;
  authChannelRetryTimeout: any;
  authChannelReconnectEnabled: boolean = false;
  constructor(private _tokenService: AngularTokenService,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    public authService: AuthorizationService, private router: Router,
    private KeyValueService: KeyValue, private websocketService: WebsocketService,
    private renderer: Renderer2) {
    this.user_email = this.authService.getEmail();
    this.nick_name = this.authService.getCRole();

    KeyValue.animStatus.subscribe(
      data => {
        // console.log('listening .... '+data);
        data === 'start' ? KeyValue.startAnim() : KeyValue.endAnim()
      }
    )
  }

  addNonceToDynamicallyAddedScripts(node) {
    // const scripts = document.querySelectorAll('script');
    // const styles = document.querySelectorAll('style');
    // const links = document.querySelectorAll('link');
    const nonceid = (
      document.querySelector('meta[name="CSP_NONCE"]') as HTMLMetaElement
    )?.content;

    const metas = Array.from(document.getElementsByTagName('meta'))
    const metaTitle = metas.find((m) => m.attributes[0].nodeValue === 'CSP_NONCE')
    metaTitle.attributes[1].nodeValue = nonceid;


    const addNonce = (ele1) => {
      if (!ele1.hasAttribute('nonce') || ele1.getAttribute('nonce') == '') {
        this.renderer.setAttribute(ele1, 'nonce', nonceid); // Replace with your actual nonce value
      }
    }

    addNonce(node);
    // scripts.forEach(script => {
    //   addNonce(script);
    // });

    // styles.forEach(script => {
    //   addNonce(script);
    // });

    // links.forEach(script => {
    //   addNonce(script);
    // });
  }

  // ngAfterContentChecked() {
  //   if (this._tokenService.userSignedIn()) {//this._tokenService.currentUserData.uid;
  //     this.first_name = this.authService.getFirstName();
  //     this.last_name = this.authService.getLastName();
  //   }
  // }

  logout() {
    //closing the account lock popup
    const modal = document.getElementById("myLogoutModel");
    if (modal) {
      modal.style.display = "none";
    }
    // Remove the modal-backdrop class
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.parentNode.removeChild(backdrop);
    }
    // this.router.navigate([KeyValue.signinPath])
    this.closeAuthChannelSocket();
    this.authService.logout();
  }

  closeAuthChannelSocket() {
    this.authChannelReconnectEnabled = false;
    if (this.authChannelRetryTimeout) {
      clearTimeout(this.authChannelRetryTimeout);
      this.authChannelRetryTimeout = null;
    }
    if (this.authChannelSocket &&
      (this.authChannelSocket.readyState === WebSocket.OPEN || this.authChannelSocket.readyState === WebSocket.CONNECTING)) {
      this.authChannelSocket.close();
    }
    this.authChannelSocket = null;
  }

  initWebChannel() {
    console.log('Socket initialization for Auth Channel');
    const that = this;
    let retryCount = 0;
    const maxRetryDelay = 30000;
    this.authChannelReconnectEnabled = true;

    function scheduleWebSocketRetry(timeout = 5000) {
      if (!that.authChannelReconnectEnabled || that.authChannelRetryTimeout) {
        return;
      }

      that.authChannelRetryTimeout = setTimeout(function () {
        that.authChannelRetryTimeout = null;
        setupWebSocket();
      }, timeout);
    }

    function setupWebSocket() {
      if (!that._tokenService.userSignedIn()) {
        console.log("User not authenticated, retrying WebSocket connection after login");
        scheduleWebSocketRetry();
        return;
      }

      const auth = that._tokenService.currentAuthData;
      if (!auth || !auth.uid || !auth.accessToken || !auth.client) {
        console.log("Missing authentication data for WebSocket");
        scheduleWebSocketRetry();
        return;
      }

      if (that.authChannelSocket &&
        (that.authChannelSocket.readyState === WebSocket.OPEN || that.authChannelSocket.readyState === WebSocket.CONNECTING)) {
        return;
      }

      let tokenParams = "uid=" + encodeURIComponent(auth.uid) +
        "&access-token=" + encodeURIComponent(auth.accessToken) +
        "&client=" + encodeURIComponent(auth.client);

      if (auth.expiry) {
        tokenParams += "&expiry=" + encodeURIComponent(auth.expiry);
      }

      that.authChannelSocket = new WebSocket(environment.chat_base_url + "?" + tokenParams);

      that.authChannelSocket.onopen = function () {
        console.log("WebSocket connection opened");
        that.authChannelSocket.send(JSON.stringify({ "command": "subscribe", "identifier": "{\"channel\":\"AuthChannel\"}" }));
        retryCount = 0; // Reset retry count on successful connection
      };

      that.authChannelSocket.onmessage = function (msg) {
        const data1 = JSON.parse(msg.data);
        if (data1.message !== undefined) {
          that.websocketService.wsocketAction(data1);
        }
      };

      that.authChannelSocket.onerror = function (err) {
        console.error("WebSocket encountered error:", err);
      };

      that.authChannelSocket.onclose = function (event) {
        console.log("WebSocket connection closed", event);
        that.authChannelSocket = null;
        if (that.authChannelReconnectEnabled && that._tokenService.userSignedIn()) {
          const timeout = Math.min((retryCount + 1) * 10 * 1000, maxRetryDelay);
          console.log(`WebSocket connection lost, retrying in ${timeout / 1000} seconds...`);
          retryCount++;
          scheduleWebSocketRetry(timeout);
        }
      };
    }

    // Initial setup
    setupWebSocket();

    // Network status listener
    window.addEventListener('offline', function () {
      console.log("Network went offline");
      if (that.authChannelSocket && that.authChannelSocket.readyState === WebSocket.OPEN) {
        that.authChannelSocket.close(); // Close WebSocket when network goes offline
      }
    });

    window.addEventListener('online', function () {
      console.log("Network is back online");
      retryCount = 0; // Reset retry count
      setupWebSocket(); // Reconnect WebSocket immediately when network is back online
    });
  }

  ngAfterViewInit() {
    this.observeDOMForNewScriptsAndStyles();
  }

  observeDOMForNewScriptsAndStyles() {
    const targetNode = document.documentElement; // or a specific node to observe
    const config = { childList: true, subtree: true }; // Observe changes in all child elements

    const callback = (mutationsList: MutationRecord[]) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE' || node.nodeName === 'LINK') {
            this.addNonceToDynamicallyAddedScripts(node); // Pass the added nodes
          }
        });
      });
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  ngOnInit() {
    const scripts = document.querySelectorAll('script');
    const styles = document.querySelectorAll('style');
    const links = document.querySelectorAll('link');

    scripts.forEach(script => {
      this.addNonceToDynamicallyAddedScripts(script);
    });

    styles.forEach(script => {
      this.addNonceToDynamicallyAddedScripts(script);
    });

    links.forEach(script => {
      this.addNonceToDynamicallyAddedScripts(script);
    });
    // 
    //  console.log('init called');
    KeyValue.animStatus_update('end');
    const that = this;
    setTimeout(function () { that.initWebChannel() }, 9000);

    if (this._tokenService.userSignedIn()) {
      if (this._tokenService.currentUserData == null) {
        this._tokenService.validateToken().subscribe(
          res => {
            console.log('....' + JSON.stringify(res));
            localStorage.setItem('currentUserData', JSON.stringify(res));
          },
          error => {
            console.log(error);
          }
        );

      }
      if (this.authService.logoutTimerStarted === false) {
        this.authService.logoutTimerStarted = true;
        this.authService.startTimer(); // Use default 5-hour timeout
      }
    }

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        this.titleService.setTitle(data['title'] || 'BankExec®');
          const liveRegion = document.getElementById('live-region');
          if (liveRegion) {
            liveRegion.textContent = (data['title'] || 'BankExec®');
          }
      });
    // Not required now as we hv commented out the delete token worker.
    // Function which runs every 1 minutes and update the token last updated time
    // setInterval(() => {
    //   if (this._tokenService.userSignedIn()) {
    //     this.uid = this.authService.getID();
    //     this.authService.post(KeyValue.api_client_ping, { id: this.uid }).pipe(map(res => res)).subscribe(
    //       data => {
    //         if (data.status == 201) {
    //           console.log("token time Updated: " + data.time);
    //           console.log(data.message)
    //           console.log("data.message")
    //         } else {
    //           console.log("error while updating user token time");
    //         }
    //       },
    //       error => {
    //         console.log('Update user token error' + error)
    //       }
    //     );
    //   }
    // }, 60000);
  }

}
